module.exports = __webpack_public_path__ + "img/caas4.3f445395.jpg";